import { ChangeEvent } from 'react';

interface Props {
    event: ChangeEvent<HTMLInputElement>;
    paddingTop: number;
    paddingBottom: number;
    paddingRight: number;
    paddingLeft: number;
}

/**
 * Generates a { key, value } object to increase or decrease element padding,
 * either via arrow buttons or entering a number manually
 */
export default ({ event, paddingTop, paddingRight, paddingBottom, paddingLeft }: Props) => {
    const { id, value: stringValue } = event.currentTarget;
    const value = +stringValue;
    const isKeyboardEntry = typeof stringValue === 'string';
    const [direction, adjustment] = id.split('-');
    const amount = adjustment === 'increase' ? 1 : -1;
    switch (direction) {
        case 'paddingLeft':
            return { key: 'paddingLeft', value: isKeyboardEntry ? value : paddingLeft + amount };
        case 'paddingTop':
            return { key: 'paddingTop', value: isKeyboardEntry ? value : paddingTop + amount };
        case 'paddingRight':
            return { key: 'paddingRight', value: isKeyboardEntry ? value : paddingRight + amount };
        case 'paddingBottom':
            return { key: 'paddingBottom', value: isKeyboardEntry ? value : paddingBottom + amount };
        case 'minusAllPadding': {
            return { key: 'updateAllPadding', value: -1 };
        }
        case 'plusAllPadding': {
            return { key: 'updateAllPadding', value: 1 };
        }
        default:
            return null;
    }
};
